export default __webpack_public_path__ + "static/media/github.4aa9f4c8.svg";